import React, { useRef, useEffect, useContext } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { ReactTyped } from "react-typed";
import myimg from "../Images/myimg.png";
import "../FirstSection/FirstSection.css";
import ThemeContext from "../Darktheme/ThemeContext";
import ParticlesComponent from "../particles/ParticlesComponent";
import { Helmet } from "react-helmet";

const FirstSection = () => {
  const { darkMode } = useContext(ThemeContext);
  const imgRef = useRef(null);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000, // Duration of animation in ms
      easing: "ease-in-out", // Easing function for animation
      once: true, // Whether animation should happen only once
    });

    // Hover effect for the image
    const handleMouseMove = (e) => {
      const img = imgRef.current;
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;

      const rotateX = (y / rect.height) * 30;
      const rotateY = (x / rect.width) * -30;

      img.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    };

    const handleMouseLeave = () => {
      const img = imgRef.current;
      img.style.transform = "rotateX(0) rotateY(0)";
    };

    const img = imgRef.current;
    img.addEventListener("mousemove", handleMouseMove);
    img.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      img.removeEventListener("mousemove", handleMouseMove);
      img.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <>
    <Helmet>
        <title>Tinu Kumar | Full Stack Developer</title>
        <meta name="description" content="I am Tinu Kumar, a web developer specializing in full-stack development, data analytics, and machine learning." />
        <meta name="keywords" content="Tinu Kumar, web development, full stack, data analysis, machine learning, blogging, tech writing" />
        <meta name="author" content="Tinu Kumar" />
        <meta property="og:title" content="Tinu Kumar | Full Stack Developer" />
        <meta property="og:description" content="Explore my portfolio of web development, data analysis, and machine learning projects." />
        <meta property="og:image" content={myimg} />
        <meta property="og:type" content="website" />
      </Helmet>

    <div className="firstsectionpart">
    <ParticlesComponent id="tsparticles"  /> 
      <div className={`firstSection ${darkMode ? "dark" : ""}`}>
        <div className="firstsectionContent" data-aos="fade-up">
          <h1>Hi There <span className="wave">👋</span></h1>
          <h1>
            I am <span>Tinu Kumar</span>
          </h1>
          <div>
            <p>
              I am into {" "}
              <ReactTyped style={{ paddingLeft: "0.2rem" }}
                strings={[
                  "Web Development",
                  "Data Analyst",
                  "Frontend ",
                  "Backend ",
                  "ML Development",
                  "Tech Writing",
                  "Blogging"
                  
                ]}
                loop
                backSpeed={20}
                typeSpeed={100}
                showCursor={true}
              />
            </p>
          </div>
        </div>

        <div className="firstsectionImg" data-aos="zoom-in">
          <img src={myimg} alt="Profile" ref={imgRef} />
        </div>
      </div>
    </div>  
    
    </>
  );
};

export default FirstSection;






